export const TRANSLATIONS_AR = {
    letsmake:"دعونا نجعل عملك",
    moreprofit:"أكثر ربحية",
    createaccount:"قم بإنشاء حساب جديد مع Planigo",
    getstart:"البدء",
    support:"الدعم",
    toservice:"شروط الخدمة",
    ppolicy:"سياسة خاصة",
    siginbtn:"تسجيل الدخول",
    nextgen:"الجيل القادم",
    insaletec: "في تقنيات البيع",
    sintoacc: "تسجيل الدخول إلى حسابك",
    formfield: {
        email: "عنوان بريد الكتروني",
        pass: "كلمة المرور",
        forgetpw: "نسيت كلمة المرور"
    },
    noaccyet: "ليس لديك حساب حتى الآن؟",
    cnewacc: "انشاء حساب جديد",
};